/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2023 - 2023
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import messages from "../../../helpers/messages";
import ThumbsDownIcon from "../../icons/ThumbsDownIcon";

function ProcurementViewRejectedState() {
  return (
    <>
      <p className="inline-block font-size-14 pt-16 mb-0">
        {messages.bidWasRejectedForCarrierMatching.defaultMessage}
      </p>
      <p className="inline-block font-size-14 pt-16 mb-0 fr text-red-failure-dark mr-24">
        <ThumbsDownIcon
          height="16px"
          width="16px"
          className="mr-8 align-middle"
        />
        {messages.rejectedForCarrierMatching.defaultMessage}
      </p>
    </>
  );
}

export default ProcurementViewRejectedState;
